// 公司公证
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let cnpj = get(state, 'currentContractorDetail.contractorInfo.docInfo.cnpj', {})
  return {
    title: i18n.gettext('CNPJ'),
    content: [
      {
        title: i18n.gettext('证号'),
        label: cnpj.id
      },
      {
        title: i18n.gettext('执照照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: cnpj.licensePics
      }
    ]
  }
}
